/**
 * Branding
 */

// Module dependencies
import 'protons';
import 'atoms/image';
import './logo--basf2020.svg';

// Module template
import './_branding.css';
import './_branding.twig';

export const name = 'branding';

export function disable() {}

export function enable() {}

export default enable;
